// extracted by mini-css-extract-plugin
module.exports = {"atmosphericHeader":"index_atmosphericHeader_26g0t","backgroundImage":"index_backgroundImage_3aFTt"};